import i18n from '@/lang';

// 丢失类型
export const LOST_TYPE = Object.freeze({
  // 1: {
  //   label: i18n.t('operationTips.confirmLost'), // 确认丢失
  //   value: 1
  // },
  // 2: {
  //   label: i18n.t('operationTips.yisiLost'), // 疑似丢失
  //   value: 2
  // },
  // 3: {
  //   label: i18n.t('operationTips.timeoutFailed'), // 超时未妥投
  //   value: 3
  // },
  // 4: {
  //   label: i18n.t('operationTips.packageHasBeenIntercepted'), // 包裹已被拦截
  //   value: 4
  // }
  1: {
    label: i18n.t('operationTips.packageConfirmedLost'), // 包裹确认丢失
    value: 1
  },
  2: {
    label: i18n.t('operationTips.packageStolenOrRobbed'), // 包裹被抢或被盗
    value: 2
  },
  3: {
    label: i18n.t('operationTips.timeoutFailed'), // 超时未妥投
    value: 3
  },
  4: {
    label: i18n.t('operationTips.packageHasBeenIntercepted'), // 包裹已被拦截
    value: 4
  },
  5: {
    label: i18n.t('newOrder.AllDamaged'), // 全部破损
    value: 5
  },
  6: {
    label: i18n.t('operationTips.partiallyDamaged'), // 部分破损
    value: 6
  },
  7: {
    label: i18n.t('newOrder.AllStolen'), // 全部被盗
    value: 7
  },
  8: {
    label: i18n.t('operationTips.partiallyStolen'), // 部分被盗
    value: 8
  }
});
